<button class="cross">
  <wchfs-icon svgIcon="pso:chipcross_m" size="24"></wchfs-icon>
</button>
